import React from 'react';
import Modal, { ModalTransition } from '@atlaskit/modal-dialog';

import usePopup from '../../hooks/usePopup';
import ErrorBoundary from '../Common/ErrorBoundary';
import Button from '../../kingpin/atoms/Button';
import PeerGroupInfoPopup from './PeerGroupInfoPopup';

const PeerInfoButtonContainer = ({
  gadget,
}: {
  gadget: VisualisationDefinitions.GroupVsRemainder;
}) => {
  const { isOpen, open, close } = usePopup();

  return (
    <>
      <Button
        testId={'peer-group-info'}
        onClick={open}
        isDisabled={false}
        icon={'help'}
        type="Ghost"
        size="Small"
      />
      <ModalTransition>
        {isOpen && (
          <Modal
            onClose={close}
            shouldScrollInViewport={false}
            autoFocus={false}
          >
            <PeerGroupInfoPopup gadget={gadget} close={close} />
          </Modal>
        )}
      </ModalTransition>
    </>
  );
};

const Gate = ({
  gadget,
}: {
  gadget: VisualisationDefinitions.GroupVsRemainder;
}) => (
  <ErrorBoundary isHiddenError>
    <PeerInfoButtonContainer gadget={gadget} />
  </ErrorBoundary>
);

export default Gate;
